import { BomTableComparisonComponent } from './features/user/components/bom-table-comparison/bom-table-comparison/bom-table-comparison.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangePasswordComponent } from './base/components/change-password/change-password.component';
import { ForgotPasswordComponent } from './base/components/forgot-password/forgot-password.component';
import { LoginComponent } from './base/components/login/login.component';
import { NotfoundComponent } from './base/components/notfound/notfound.component';
import { AuthGuard } from './base/guards/auth.guard';
import { HomeComponent } from './features/public/components/home/home.component';
import { UserDashboardComponent } from './features/user/components/user-dashboard/user-dashboard.component';
import { ResetPasswordComponent } from './base/components/reset-password/reset-password.component';
import { UploadFileComponent } from './shared/components/old_upload-file/upload-file.component';
import { CreateClientComponent } from './features/admin/components/client/create-client/create-client.component';
import { UpdateClientComponent } from './features/admin/components/client/update-client/update-client.component';
import { UploadFileListComponent } from './features/admin/components/upload-file-list/upload-file-list.component';
import { UpdateUserComponent } from './features/admin/components/user/update-user/update-user.component';
import { CreateUserComponent } from './features/admin/components/user/create-user/create-user.component';
import { DeleteUserComponent } from './features/admin/components/user/delete-user/delete-user.component';
import { AccountComponent } from './features/user/components/account/account.component';
import { View3dComponent } from './features/user/components/view3d/view3d.component';
import { AdminDashboardComponent } from './features/admin/components/admin-dashboard/admin-dashboard.component';
import { DemoRequestComponent } from './features/public/components/demo-request/demo-request.component';
import { DemoComponent } from './features/public/components/demo/demo.component';
import { UserComponent } from './features/admin/components/user/user.component';
import { ContactUsComponent } from './base/components/contact-us/contact-us.component';
import { UserManagementComponent } from './features/user/components/user-management/user-management.component';
import { TestLoadingComponent } from './features/test-loading/test-loading.component';
import { CommunicationPanelComponent } from './features/admin/components/communication-panel/communication-panel.component';
import { DrafterMessageComponent } from './features/user/components/topic/drafter-message/drafter-message.component';
import { OffereePageComponent } from './features/user/components/commercial-offers/offeree-page/offeree-page.component';
import { DocumentationComponent } from './features/user/components/documentation-component/documentation.component';


const routes: Routes = [
  { path: '', redirectTo: '/user', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  { path: 'forgotpassword', component: ForgotPasswordComponent },
  { path: 'resetpassword', component: ResetPasswordComponent },
  { path: 'changepassword', component: ChangePasswordComponent },
  { path: 'account', component: AccountComponent },
  { path: 'view3d', component: View3dComponent },
  { path: 'uploadfile', component: UploadFileComponent },
  { path: 'demorequest', component: DemoRequestComponent },
  { path: 'demo', component: DemoComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'test-loading', component: TestLoadingComponent },
  { path: 'quotes/:id', component: OffereePageComponent },
  {     path: 'documentation', component: DocumentationComponent },
  { path: 'file-explorer', loadChildren: () => import('./features/file-explorer/file-explorer.module').then(m => m.FileExplorerModule) },
  {
    path: 'admin',
    component: AdminDashboardComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['ADMIN'],
    },
    children: [
      {
        path: 'createclient',
        component: CreateClientComponent,
      },
      {
        path: 'updateclient',
        component: UpdateClientComponent,
      },
      {
        path: 'createuser',
        component: CreateUserComponent,
      },
      {
        path: 'updateuser',
        component: UpdateUserComponent,
      },
      {
        path: 'deleteuser',
        component: DeleteUserComponent,
      },
      {
        path: 'listoffiles',
        component: UploadFileListComponent,
      },
      {
        path: 'communications',
        component: CommunicationPanelComponent,
      },
      {
        path: 'user',
        component: UserComponent, // Or UserDashboardComponent if not creating a new UserComponent
        canActivate: [AuthGuard],
        data: {
          roles: ['GENERAL_USER', 'ADMIN', 'CUSTOMER_ADMIN', "CUSTOMER_USER", "TEST_USER"],
        },
        children: [
          {
            path: '',
            component: UserDashboardComponent,
          },

          // ... other child routes ...
        ],
      },
      {
        path: 'users/:userId',
        component: UpdateUserComponent,
      },
    ],
  },
  {
    path: 'user',
    canActivate: [AuthGuard],
    data: {
      roles: ['GENERAL_USER', 'ADMIN', 'CUSTOMER_ADMIN', "CUSTOMER_USER","TEST_USER"],
    },
    children: [
      {
        path: '',
        component: UserDashboardComponent
      },
      {
        path: 'comparison',
        component: BomTableComparisonComponent
      },
      {
        path: 'management',
        component: UserManagementComponent
      },
      {
        path: 'messages',
        component: DrafterMessageComponent,
      },
      {
        path: 'quotes',
        loadChildren: () => import('./features/user/components/commercial-offers/commercial-offers.module').then(m => m.CommercialOffersModule),
        data: {
          roles: ['GENERAL_USER', 'ADMIN', 'CUSTOMER_ADMIN', "CUSTOMER_USER","TEST_USER"],
        }
      },
      {
        path: 'rfp-requests',
        loadChildren: () => import('./features/user/components/rfp-requests/rfp-requests.module').then(m => m.RfpRequestsModule),
        data: {
          roles: ['GENERAL_USER', 'ADMIN', 'CUSTOMER_ADMIN', "CUSTOMER_USER","TEST_USER"],
        }
      },
      {
        path: '**',
        component: UserDashboardComponent
      }
    ]
  },
  {
    path: 'templates',
    loadChildren: () => import('./shared/components/templates-component/templates-component.module').then(m => m.TemplatesComponentModule)
  },
  {
    path: 'contractor',
    loadChildren: () => import('./features/contractor/contractor.module').then(m => m.ContractorModule)
  },
  { path: '**', component: NotfoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
